import React from 'react';
import styled, { ThemeConsumer } from 'styled-components';

// Components
import { IconAccidentFilled } from 'wg-fe-ui';

// Types
import { useTranslation } from 'react-i18next';
import { mq } from '../../../../../../common/src/utils/styledComponentsUtils';
import { PiaClaim } from './PiaClaimsInputComponent';
import { HStack, Text } from '@chakra-ui/react';

interface Props {
  accident: PiaClaim;
  onClick: () => void;
}

const AccidentDisplay: React.FC<React.PropsWithChildren<Props>> = ({
  accident,
  onClick,
}) => {
  const { t } = useTranslation();
  return (
    <ThemeConsumer>
      {(theme) => (
        <Wrapper onClick={onClick} data-test-id="ProdFac_AccidentDisplay">
          <HStack spacing="2" mr="10">
            <IconWrapper>
              <IconAccidentFilled color={theme.primary[500]} size={35} />
            </IconWrapper>
            <Text>{t(accident.cause)}</Text>
          </HStack>
          <AccidentDateWrapper data-test-id="ProdFac_AccidentDisplay_AccidentDate">
            <Label>{t('Loss amount')}</Label>
            <Value>{t(accident.loss_amount)}</Value>
          </AccidentDateWrapper>
          <AtFaultWrapper data-test-id="ProdFac_AccidentDisplay_AtFault">
            <Label> {t('What year did it occur')}</Label>
            <Value>{t(accident.year)}</Value>
          </AtFaultWrapper>
        </Wrapper>
      )}
    </ThemeConsumer>
  );
};

const AccidentDateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
  ${mq.mobileL} {
    flex-grow: 0;
  }
`;

const AtFaultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  margin-right: 1.6rem;

  ${mq.mobileL} {
    align-items: flex-start;
  }
`;

const Label = styled.label`
  font-size: 1.4rem;
  line-height: 125%;
  color: #8990a3;
`;

const Value = styled.p`
  font-size: 1.8rem;
  line-height: 120%;

  ${mq.mobileL} {
    font-size: 1.6rem;

    &:first-of-type {
      margin-bottom: 1.6rem;
    }
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  width: 5rem;
  height: 5rem;
  border-radius: 2.5rem;
  background-color: ${({ theme }) => theme.primary[100]};
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;

  color: #31263d;

  ${mq.mobileL} {
    flex-direction: column;

    > div:first-child {
      margin-bottom: 1.6rem;
    }

    > div:last-child {
      margin-top: 0.8rem;
    }
  }
`;

export default AccidentDisplay;
